import { UserProfile } from '@/src/interfaces'

export const mockUserProfile: UserProfile = {
  id: '1',
  client_id: '1',
  created_at: '2021-01-01',
  updated_at: '2021-01-01',
  is_active: true,
  first_name: 'John',
  middle_name: '',
  last_name: 'Doe',
  full_name: 'John Doe',
  birthdate: '1990-01-01',
  gender: 'Male',
  email: 'john.doe@example.com',
  phone: '1234567890',
  address: '123 Main St',
  city: 'New York',
  state: 'NY',
  zip: '10001',
  primary_insurance: 'Blue Cross',
  username: 'johndoe',
  profile_picture: 'https://example.com/photo.jpg',
  lat: 40.7128,
  lon: -74.006,
}
